export const MIN_SEARCH_QUERY_LENGTH = 2;
